var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M240 50c16.569 0 30 13.432 30 30v120c0 16.569-13.431 30-30 30H40c-16.568 0-30-13.431-30-30V80c0-16.568 13.432-30 30-30zm-20.433 36.604-74.135 47.97a10 10 0 0 1-10.865 0l-74.134-47.97c-4.637-3-10.828-1.673-13.829 2.964-3 4.636-1.673 10.827 2.964 13.828l74.134 47.969a30 30 0 0 0 32.596 0l74.134-47.969c4.637-3.001 5.964-9.192 2.964-13.828-3.001-4.637-9.192-5.964-13.829-2.964"
})));
export default SvgMail;